import Monitoring from 'app/developer-v3/pages/monitoring';

export default {
  routes: {
    '.': Monitoring,
  },
};
